<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData"></mainHead> -->
		<!-- <div class="pageTopBox space_between">
			<div class="titleText">媒体收入</div>
			<div class="addBtn flex_start">
				<el-button type="primary" icon="el-icon-refresh" size="small" @click="mediaSyncAll"
					v-hasPermi="['dataManage:mediaIncome:async']">一键同步</el-button>
				<el-button type="primary" icon="el-icon-download" size="small" @click="mediaExport(1)"
					v-hasPermi="['dataManage:mediaIncome:export']">导出数据</el-button>
				<el-button type="primary" icon="el-icon-download" size="small" @click="mediaExport(2)"
					v-hasPermi="['dataManage:mediaIncome:export']">导出详情</el-button>
				<el-upload class="upload-demo" ref='upload' action="#" :auto-upload="true" :show-file-list="false"
					:on-change="(file) => uploadFun(file)" :http-request="uploadSet">
					<el-button type="primary" icon="el-icon-upload2" size="small">导入</el-button>
				</el-upload>
			</div>
		</div> -->
		<div class="mianPage">
			<div class="topSearch space_between">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" :clearable="false">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.companyName" filterable clearable size="small" placeholder="请选择媒体公司"
						@change="companySelectChange">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.os" clearable size="small" placeholder="请选择操作系统">
							<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<!-- <el-select v-model="queryData.appId" filterable clearable size="small" placeholder="请选择应用">
							<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select> -->
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()">
							<el-option v-for="item in mediaAppOptions" :key="item.value"
								:value="item" :label="`应用：${item.label} | ${item.value}`">
								<!-- :label="`应用：${item.label} | ${item.value}`" -->
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.adType" clearable size="small" placeholder="请选择广告类型">
							<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<!-- <el-input clearable size="small" style="width:210px" placeholder="请输入广告位" v-model="queryData.adsId"></el-input> -->
						<el-select v-model="adsSelectForm" clearable @change="adsSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable @clear="getMediaAdsOption(2)"
							:remote-method="adsRemoteMethod" :loading="adsRemoteLoading" remote placeholder="请选择聚合广告位">
							<el-option v-for="item in mediaAdsOptions" :key="item.value" :label="`广告位：${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.syncStatus" clearable size="small" placeholder="请选择同步状态">
							<el-option v-for="item in syncStatusOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.appProperty" clearable size="small" placeholder="请选择应用属性">
							<el-option v-for="item in appPropertyOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<div class="searchMenuRight">
					<el-button type="primary" @click="confirmQuery" size="small"
						v-hasPermi="['dataReport:mediaIncome:query']">查询</el-button>
					<div></div>
					<el-button @click="searchReset" size="small" v-hasPermi="['dataReport:mediaIncome:query']">重置</el-button>
				</div>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<div class="tHeadRow flex_start">
					<div class="tHeadleftTips">查看维度</div>
					<el-checkbox :indeterminate="isDimensionIndeterminate" v-model="dimensionCheckAll" @change="handleCheckAllChangeDim"
					style="margin-right: 30px;">全选</el-checkbox>
					<el-checkbox-group v-model="tHeaderQueryChecked" class="tHeadFixedCheckList">
						<el-checkbox v-for="(item,index) in tHeaderQueryData" :label="item.valueNum" size="mini"
							:checked="item.checked" :key="index" :name="item.value" class="check-box-fixed"
							@change="checkBoxQueryChange($event,item,index)">{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
					<div class="tableBtns flex_start">
						<el-button @click="editTheadDialog" size="small"><i class="el-icon-setting"></i>
							自定义指标</el-button>
						<el-button type="primary" icon="el-icon-refresh" size="small" plain @click="mediaSyncAll"
							v-hasPermi="['dataReport:mediaIncome:async']">一键同步</el-button>
						<el-button type="primary" icon="el-icon-download" size="small" plain @click="mediaExport(1)"
							v-hasPermi="['dataReport:mediaIncome:export']">导出</el-button>
						<el-button type="primary" icon="el-icon-download" size="small" plain @click="mediaExport(2)"
							v-hasPermi="['dataReport:mediaIncome:export']">导出详情</el-button>
						<el-upload class="upload-demo" ref='upload' v-hasPermi="['dataReport:mediaIncome:import']" action="#" :auto-upload="true" :show-file-list="false"
							:on-change="(file) => uploadFun(file)" :http-request="uploadSet">
							<el-button type="primary" icon="el-icon-upload2" size="small" plain>导入</el-button>
						</el-upload>
					</div>
				</div>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table" @selection-change="handleSelectionChange" ref="multipleTable"
					@expand-change="handleExpandChange" @sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass"
					:row-class-name="tableRowClassName">
					<el-table-column type="selection" :selectable="checkSelectable" width="55"></el-table-column>
					<el-table-column type="expand" fixed>
						<template slot-scope="props">
							<el-table :data="props.row.tabList" class="el_tables"
								:header-cell-style="{color:'#333333',background:'#F6FEFF'}" @sort-change="(sortObj) => sortChangeFunSec(sortObj,props.row,props.$index)" 
								:header-cell-class-name="handleHeadAddClassSec">
								<el-table-column :fixed="shouldFixDimensionColumn" min-width="100"></el-table-column>
								<el-table-column prop="platformName" min-width="160" label="广告网络" v-if="tHeaderQueryChecked.indexOf(2) !== -1"
								:fixed="shouldFixDimensionColumn"></el-table-column>
								<el-table-column prop="" min-width="90" label="操作系统" v-if="tHeaderQueryChecked.indexOf(3) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="props.row.os">
											<div>{{props.row.os}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<el-table-column prop="" min-width="160" label="应用" v-if="tHeaderQueryChecked.indexOf(4) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="props.row.appId">
											<div>{{props.row.appName}}</div>
											<div style="color: #999999;">{{props.row.appId}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<el-table-column prop="" min-width="100" label="广告位类型" v-if="tHeaderQueryChecked.indexOf(5) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="props.row.type">
											<div>{{getAdTypeRenderText(props.row)}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<el-table-column prop="" min-width="180" label="广告源" v-if="tHeaderQueryChecked.indexOf(6) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="scope.row.platAdsId">
											<div>{{scope.row.platAdsName}}</div>
											<div style="color: #999999;">{{scope.row.platAdsId}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<template v-for="(columnObj,index) in tHeadCheckedList">
									<el-table-column v-if="columnObj.prop == 'showNum'" :prop="columnObj.prop" label="广告展示量"
										align="right" :width="columnObj.width" :fixed="columnObj.fixed"
										:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
									</el-table-column>
									<el-table-column v-else-if="columnObj.prop == 'uniqueClickNum'" :prop="columnObj.prop" label="广告点击量(去重)"
										align="right" :width="columnObj.width" :fixed="columnObj.fixed"
										:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
									</el-table-column>
									<el-table-column v-else-if="columnObj.prop == 'deductClickNum'" :prop="columnObj.prop" label="广告点击量(扣量后)"
										align="right" :width="columnObj.width" :fixed="columnObj.fixed"
										:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
									</el-table-column>
									<!-- <el-table-column v-else-if="columnObj.prop == 'estimateProfit'" :prop="columnObj.prop" label="广告预估收益(¥)"
										align="right" :width="columnObj.width" :fixed="columnObj.fixed"
										:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
									</el-table-column> -->
									<el-table-column v-else :prop="columnObj.prop" :label="columnObj.label"
										align="right" :width="columnObj.width" :fixed="columnObj.fixed"
										:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
									</el-table-column>
								</template>
								<el-table-column :fixed="isMobileOrTablet ? false : 'right'" width="120"></el-table-column>
							</el-table>
						</template>
					</el-table-column>
					<el-table-column prop="recordTime" label="日期" min-width="100"
					:fixed="shouldFixDimensionColumn"></el-table-column>
					<el-table-column prop="companyName" label="媒体公司" min-width="160" v-if="tHeaderQueryChecked.indexOf(2) !== -1"
					:fixed="shouldFixDimensionColumn"></el-table-column>
					<el-table-column prop="os" label="操作系统" min-width="90" v-if="tHeaderQueryChecked.indexOf(3) !== -1"
					:fixed="shouldFixDimensionColumn"></el-table-column>
					<el-table-column prop="appName" label="应用" min-width="160" v-if="tHeaderQueryChecked.indexOf(4) !== -1"
					:fixed="shouldFixDimensionColumn">
						<template slot-scope="scope">
							<div v-if="scope.row.appName">
								<div>{{scope.row.appName}}</div>
								<div style="color: #4F7AFD;">{{scope.row.appId}}</div>
							</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="广告类型" min-width="130" v-if="tHeaderQueryChecked.indexOf(5) !== -1"
					:fixed="shouldFixDimensionColumn">
						<template slot-scope="scope">
							<span>{{getAdTypeRenderText(scope.row)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="adName" label="聚合广告位" min-width="180" v-if="tHeaderQueryChecked.indexOf(6) !== -1"
					:fixed="shouldFixDimensionColumn">
						<template slot-scope="scope">
							<div v-if="scope.row.adName">
								<div>{{scope.row.adName}}</div>
								<div style="color: #4F7AFD;">{{scope.row.adsId}}</div>
							</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="cooperationType" label="合作模式">
						<template slot-scope="scope">
							<div v-if="scope.row.cooperationType==1">ADN</div>
							<div v-else-if="scope.row.cooperationType==2">聚合-黑盒</div>
							<div v-else-if="scope.row.cooperationType==3">聚合-回转价格</div>
							<div v-else>-</div>
						</template>
					</el-table-column> -->
					<template v-for="(columnObj,index) in tHeadCheckedList">
						<!-- <el-table-column v-if="columnObj.prop == 'showNum'" :prop="columnObj.prop" label="广告展示量"
							align="right" :width="columnObj.width" :fixed="columnObj.fixed"
							:sortable="columnObj.sortable?'custom':false" :key="index">
						</el-table-column> -->
						<el-table-column :prop="columnObj.prop" :label="columnObj.label"
							align="right" :width="columnObj.width" :fixed="columnObj.fixed"
							:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
							<template v-slot="scope" v-if="columnObj.temp">
								<slot :name="columnObj.prop" :scope="scope" v-if="columnObj.prop == 'apiShowNum'">
									<div v-if="scope.row.showGap" style="color: #FF4D4F;">{{scope.row.apiShowNum}}</div>
									<div v-else-if="scope.row.apiShowNum!==null">{{scope.row.apiShowNum}}</div>
									<div v-else>-</div>
								</slot>
								<slot :name="columnObj.prop" :scope="scope" v-if="columnObj.prop == 'apiClickNum'">
									<div v-if="scope.row.clickGap" style="color: #FF4D4F;">{{scope.row.apiClickNum}}</div>
									<div v-else-if="scope.row.apiClickNum!==null">{{scope.row.apiClickNum}}</div>
									<div v-else>-</div>
								</slot>
								<slot :name="columnObj.prop" :scope="scope" v-if="columnObj.prop == 'apiDeductClickNum'">
									<div v-if="scope.row.clickGap" style="color: #FF4D4F;">{{scope.row.apiDeductClickNum}}</div>
									<div v-else-if="scope.row.apiDeductClickNum!==null">{{scope.row.apiDeductClickNum}}</div>
									<div v-else>-</div>
								</slot>
								<slot :name="columnObj.prop" :scope="scope" v-if="columnObj.prop == 'apiEstimateProfit'">
									<div v-if="scope.row.profitGap" style="color: #FF4D4F;">{{scope.row.apiEstimateProfit}}</div>
									<div v-else-if="scope.row.apiEstimateProfit!==null">{{scope.row.apiEstimateProfit}}</div>
									<div v-else>-</div>
								</slot>
								<slot :name="columnObj.prop" :scope="scope" v-if="columnObj.prop == 'estimateProfit'">
									<div v-if="scope.row.editShow">
										<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
											<el-table :data="[{}]" class="el_table" :header-cell-style="{color:'#333333',background:'#EAEFF5'}">
												<el-table-column label="未改前数据">{{scope.row.lastEstimateProfit}}</el-table-column>
											</el-table>
											<el-input clearable size="small" v-model="scope.row.estimateProfit" style="width:90px" placeholder="请输入"
												slot="reference"></el-input>
										</el-popover>
									</div>
									<div v-else>{{scope.row.estimateProfit}}</div>
								</slot>
								<slot :name="columnObj.prop" :scope="scope" v-if="columnObj.prop == 'deductClickNum'">
									<div v-if="scope.row.editShow">
										<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
											<el-table :data="[{}]" class="el_table" :header-cell-style="{color:'#333333',background:'#EAEFF5'}">
												<el-table-column label="未改前数据">{{scope.row.lastClickNum}}</el-table-column>
											</el-table>
											<el-input clearable size="small" v-model="scope.row.deductClickNum" style="width:90px" placeholder="请输入"
												slot="reference"></el-input>
										</el-popover>
									</div>
									<div v-else="!scope.row.editShow">{{scope.row.deductClickNum}}</div>
								</slot>
								<slot :name="columnObj.prop" :scope="scope" v-if="columnObj.prop == 'showNum'">
									<div v-if="scope.row.editShow">
										<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
											<el-table :data="[{}]" class="el_table" :header-cell-style="{color:'#333333',background:'#EAEFF5'}">
												<el-table-column label="未改前数据">{{scope.row.lastShowNum}}</el-table-column>
											</el-table>
											<el-input clearable size="small" v-model="scope.row.showNum" style="width:90px" placeholder="请输入"
												slot="reference"></el-input>
										</el-popover>
									</div>
									<div v-else>{{scope.row.showNum}}</div>
								</slot>
							</template>
						</el-table-column>
					</template>
					<!-- <el-table-column prop="showNum" label="媒体展现数" width="110" sortable="custom" align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.editShow">
								<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
									<el-table :data="[{}]" class="el_table" :header-cell-style="{color:'#333333',background:'#EAEFF5'}">
										<el-table-column label="未改前数据">{{scope.row.lastShowNum}}</el-table-column>
									</el-table>
									<el-input clearable size="small" v-model="scope.row.showNum" style="width:90px" placeholder="请输入"
										slot="reference"></el-input>
								</el-popover>
							</div>
							<div v-else>{{scope.row.showNum}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="channelShowNum" label="渠道展现数">
						<template slot-scope="scope">
							<div v-if="scope.row.showGap" style="color: #FF4D4F;">{{scope.row.channelShowNum}}</div>
							<div v-else-if="scope.row.channelShowNum!==null">{{scope.row.channelShowNum}}</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="uniqueClickNum" label="媒体点击数(去重)" width="100" sortable="custom">
						<template slot-scope="scope">
							<div>{{scope.row.uniqueClickNum}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="channelClickNum" label="渠道点击数(去重)" width="92">
						<template slot-scope="scope">
							<div v-if="scope.row.clickGap" style="color: #FF4D4F;">{{scope.row.channelClickNum}}</div>
							<div v-else-if="scope.row.channelClickNum!==null">{{scope.row.channelClickNum}}</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="deductClickNum" label="媒体点击数(扣量后)" width="100" sortable="custom">
						<template slot-scope="scope">
							<div v-if="scope.row.editShow">
								<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
									<el-table :data="[{}]" class="el_table" :header-cell-style="{color:'#333333',background:'#EAEFF5'}">
										<el-table-column label="未改前数据">{{scope.row.lastClickNum}}</el-table-column>
									</el-table>
									<el-input clearable size="small" v-model="scope.row.deductClickNum" style="width:90px" placeholder="请输入"
										slot="reference"></el-input>
								</el-popover>
							</div>
							<div v-else="!scope.row.editShow">{{scope.row.deductClickNum}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="channelDeductClickNum" label="渠道点击数(扣量后)" width="92">
						<template slot-scope="scope">
							<div v-if="scope.row.clickGap" style="color: #FF4D4F;">{{scope.row.channelDeductClickNum}}</div>
							<div v-else-if="scope.row.channelDeductClickNum!==null">{{scope.row.channelDeductClickNum}}</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="estimateProfit" label="媒体收益" width="110" sortable="custom" align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.editShow">
								<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
									<el-table :data="[{}]" class="el_table" :header-cell-style="{color:'#333333',background:'#EAEFF5'}">
										<el-table-column label="未改前数据">{{scope.row.lastEstimateProfit}}</el-table-column>
									</el-table>
									<el-input clearable size="small" v-model="scope.row.estimateProfit" style="width:90px" placeholder="请输入"
										slot="reference"></el-input>
								</el-popover>
							</div>
							<div v-else>{{scope.row.estimateProfit}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="channelEstimateProfit" label="渠道收益">
						<template slot-scope="scope">
							<div v-if="scope.row.profitGap" style="color: #FF4D4F;">{{scope.row.channelEstimateProfit}}</div>
							<div v-else-if="scope.row.channelEstimateProfit!==null">{{scope.row.channelEstimateProfit}}</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="ecpm" label="媒体eCPM" width="110" sortable="custom"></el-table-column>
					<el-table-column prop="channelEcpm" label="渠道eCPM">
						<template slot-scope="scope">
							<div v-if="scope.row.channelEcpm!==null">{{scope.row.channelEcpm}}</div>
							<div v-else>-</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="syncStatus" label="操作" :fixed="isMobileOrTablet ? false : 'right'" width="120">
						<template slot-scope="scope">
							<div v-if="scope.$index>0">
								<!-- <el-button type="text" @click="channelDataDrawerOpen(scope.row,scope.$index)"
							v-hasPermi="['dataManage:mediaIncome:edit']">分渠道数据</el-button> -->
								<el-button type="text" v-if="!scope.row.editShow" @click="editTable(scope.row,scope.$index)"
									v-hasPermi="['dataReport:mediaIncome:edit']">编辑</el-button>
								<el-button type="text" v-else @click="editConfirm(scope.row,scope.$index)"
									v-hasPermi="['dataReport:mediaIncome:edit']">完成</el-button>
								<el-button type="text" @click="mediaAsync(scope.row.id)" v-if="scope.row.syncStatus==0"
									v-hasPermi="['dataReport:mediaIncome:async']">同步</el-button>
								<el-button type="text" :disabled="true" v-else>已同步</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 分渠道数据 -->
		<el-drawer @close="closeDrawer" :visible.sync="channelDataDrawerShow" size="65%" :wrapperClosable="false"
			:with-header="false">
			<el-card class="box-card">
				<div slot="header" class="cardTitle space_between">
					<div class="cardTitleTxt">分渠道数据</div>
					<i class="el-icon-circle-close" @click="channelDataDrawerShow=false"></i>
				</div>
				<el-form inline class="el-form flex_start">
					<el-form-item label="日期">
						<el-date-picker v-model="datePickerDrawer" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="渠道广告位ID/名称：">
						<el-input clearable size="small" style="width:210px" placeholder="请输入"
							v-model="queryDataDrawer.adsId"></el-input>
					</el-form-item>
					<!-- <el-form-item label="广告类型：">
						<el-select v-model="queryData.syncStatus" clearable size="small" style="width:210px">
							<el-option v-for="item in syncStatusOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item> -->
					<div class="menu-right">
						<!-- <el-button @click="searchReset" size="small" v-hasPermi="['dataManage:mediaIncome:query']">重置</el-button> -->
						<el-button type="primary" @click="confirmDrawerQuery" size="small"
							v-hasPermi="['dataManage:mediaIncome:query']">查询</el-button>
					</div>
				</el-form>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableDataDrawer"
					class="el_table" ref="multipleTables">
					<el-table-column prop="recordTime" label="日期"></el-table-column>
					<el-table-column prop="companyName" label="媒体广告位名称"></el-table-column>
					<el-table-column prop="name" label="渠道广告位名称" width="200">
						<template slot-scope="scope">
							<div v-if="scope.row.adName">{{scope.row.adName}}/{{scope.row.adsId}}</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="请求量"></el-table-column>
					<el-table-column prop="os" label="请求成功量"></el-table-column>
					<el-table-column prop="appName" label="后台展现量"></el-table-column>
					<el-table-column prop="cooperationType" label="展现差异率"></el-table-column>
					<el-table-column prop="showNum" label="后台点击量" width="110" align="center"></el-table-column>
					<el-table-column prop="showNum" label="点击差异率" width="110" align="center"></el-table-column>
					<el-table-column prop="channelEstimateProfit" label="收益"></el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChangeDrawer" background @current-change="handleCurrentChangeDrawer"
						:current-page="currentPageDrawer" :page-sizes="[10, 20, 30, 50]" :page-size="pageSizeDrawer"
						layout="total, sizes, prev, pager, next, jumper" :total="totalDrawer">
					</el-pagination>
				</div>
				<div class="card-bottom flex_end">
					<el-button @click="closeDrawer" type="primary" size="medium">关闭</el-button>
				</div>
			</el-card>
		</el-drawer>
		<!-- <el-dialog title="媒体信息" :visible.sync="dialogVisible"
		  width="30%">
		  <span>这是一段信息</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog> -->
		<el-dialog title="自定义指标" :visible.sync="tHeadDialogVisible" width="56%">
			<div class="tHeadEditBox space_between">
				<div class="tHeadAllList">
					<el-collapse v-model="activeNames">
						<el-collapse-item :title="item.name" :name="index" v-for="(item,index) in tHeadAllList" :key="index">
							<div class="checkList">
								<el-checkbox :indeterminate="item.isIndeterminate" v-model="item.groupChecked" class="el_check_box"
									@change="handleGroupCheckChange($event,item,index)" style="width: 100%;">全选</el-checkbox>
								<el-checkbox v-for="(items,indexs) in item.list" :key="indexs" size="medium"
									@change="checkChange($event,index,items,indexs)" v-model="items.checked" class="el_check_box">
									{{items.label}}
								</el-checkbox>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div class="tHeadCheckShowBox">
					<div class="tHeadCheckShowTitle">已选指标</div>
					<div class="tHeadCheckShowTips">上下拖动可调整排序</div>
					<div class="tHeadCheckShowList" v-show="tHeadCheckShowList.length>0">
						<div class="tHeadCheckedOne flex_start" v-for="(item,index) in tHeadCheckShowList" :key="index"
							@dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)"
							@dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)" :draggable="true">
							<!-- <i class="el-icon-notebook-2"></i> -->
							<img src="../../assets/icon/sort.png" alt="" />
							<div>{{item.label}}</div>
							<i class="el-icon-close" style="margin-left: auto;" @click.stop="deleteTHeadChecked(item,index)"></i>
						</div>
					</div>
					<el-empty description="暂无数据" v-show="tHeadCheckShowList.length<=0"></el-empty>
				</div>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeTHeadDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="confirmTHeadDialog()" size="medium">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '媒体管理',
				companyDrawerShow: false,
				isDimensionIndeterminate: false,
				dimensionCheckAll: true,
				handleSelection: "", // 存储ID
				datePicker: [],
				adTypeSelectData: [],
				osOptions: this.$api.osOptions, // OS下拉选择列表
				appPropertyOptions: this.$api.appPropertyOptions, // 应用属性下拉选择列表
				companyOptions: [], // 公司下拉选择列表
				syncStatusOptions: [{
						value: '1',
						label: '已同步'
					},
					{
						value: '0',
						label: '未同步'
					}
				], // 同步状态下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				mediaAdsOptions: [], // 广告位下拉选择列表
				adsSelectForm: {}, //广告位下拉选中数据
				adsRemoteLoading: false,
				
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型下拉选择
				queryData: {
					syncStatus: '',
					appProperty: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				rulesApi: {
					companyName: [ //公司名称
						{
							required: true,
							message: '必填项，请输入',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在 1 到 50 个字符',
							trigger: 'blur'
						}
					],
					nickName: [ //公司地址
						{
							required: true,
							message: '请输入公司简称',
							trigger: 'blur'
						},
					],
				},
				companyFormData: {},

				dialogVisible: false, // 弹框显隐
				sortField: {},
				orderBys: [],
				sortSecField: {},
				orderSecBys: [],

				channelDataDrawerShow: false,
				datePickerDrawer: [],
				currentPageDrawer: 1,
				pageSizeDrawer: 10,
				totalDrawer: 0,
				adsIdDrawer: '',
				queryDataDrawer: {},
				tableDataDrawer: [],

				expandedRows: [],
				
				tHeaderQueryChecked: [2, 3, 4, 5, 6],
				tHeaderQueryData: [
					{
						value: 'companyName',
						valueNum: 2,
						label: "媒体公司",
						checked: false
					},
					{
						value: 'os',
						valueNum: 3,
						label: "操作系统",
						checked: false
					},
					{
						value: 'mediaAppId',
						valueNum: 4,
						label: "应用",
						checked: false
					},
					{
						value: 'type',
						valueNum: 5,
						label: "广告位类型",
						checked: false
					},
					{
						value: 'mediaAdId',
						valueNum: 6,
						label: "聚合广告位",
						checked: false
					},
				],
				
				tHeadDialogVisible: false,
				activeNames: [0, 1, 2],
				tHeadAllList: [{
						name: '统计指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [{
								prop: 'showNum',
								label: "流量展示量",
								checked: false,
								sortable: true,
								minWidth: '120',
								temp: true,
							},
							{
								prop: 'uniqueClickNum',
								label: "流量点击量(去重)",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'deductClickNum',
								label: "流量点击量(扣量后)",
								checked: false,
								sortable: true,
								minWidth: '150',
								temp: true,
							},
							{
								prop: 'channelEstimateProfit',
								label: "总收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'estimateProfit',
								label: "媒体收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120',
								temp: true,
							},
							{
								prop: 'divideEstimateProfit',
								label: "分成收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'channelEcpm',
								label: "总收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140',
							},
							{
								prop: 'ecpm',
								label: "媒体收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140'
							}
						]
					},
					{
						name: 'API指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [{
								prop: 'apiShowNum',
								label: "API展示量",
								checked: false,
								sortable: true,
								minWidth: '120',
								temp: true,
							},
							{
								prop: 'apiClickNum',
								label: "API点击量(去重)",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'apiDeductClickNum',
								label: "API点击量(扣量后)",
								checked: false,
								sortable: true,
								minWidth: '140',
								temp: true,
							},
							{
								prop: 'apiEstimateProfit',
								label: "API收益(￥)",
								checked: false,
								sortable: true,
								minWidth: '120',
								temp: true,
							},
							{
								prop: 'apiEcpm',
								label: "API eCPM(￥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							}
						]
					},
					{
						name: '数据GAP',
						groupChecked: false,
						isIndeterminate: false,
						list: [{
								prop: 'showGapRate',
								label: "展示GAP率",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'clickGapRate',
								label: "点击GAP率",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'profitGapRate',
								label: "收益GAP率",
								checked: false,
								sortable: true,
								minWidth: '120'
							}
						]
					}
				],
				tHeadCheckShowList: [], // 表头选中临时展示列表
				tHeadCheckedList: [], //最终选中的表头展示数组
				// 默认展示的表头
				tHeadNormalCheckedList: [],
				dragging: null,
				isMobileOrTablet: false, // 是否为平板或手机端，移动端只保留展开列固定
				tableFixedMediaQuery: null, // 表格固定列的媒体查询对象
			}
		},
		computed: {
			// 桌面端维度少于 5 个时固定维度列，平板和手机端始终不固定
			shouldFixDimensionColumn() {
				return !this.isMobileOrTablet && this.tHeaderQueryChecked.length < 5
			},
		},
		created(){
			
		},
		mounted() {
			this.initTableFixedMediaQuery();
			// console.log(JSON.stringify(this.tHeadAllList));
			this.dateInit();
			// this.getOSOption();
			this.getMediaAppOption();
			// this.getADTypeOption();
			this.getMediaAdsOption(2, null); // 获取聚合广告位下拉列表
			this.getCompanyOption();
			if (localStorage.getItem('sdk-mediaIncomeTHead')) {
				this.tHeadCheckedList = JSON.parse(localStorage.getItem('sdk-mediaIncomeTHead'))
			}else{
				this.tHeadAllList.forEach((category, categoryIndex) => {
					const foundItem = category.list.forEach(items => {
						this.$set(items, 'checked', true);
						this.tHeadNormalCheckedList.push(items);
					});
				});
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
			}
			// this.getMediaAdsOption();
			this.getTableData();
		},
		beforeDestroy() {
			// 组件销毁时移除媒体查询监听，避免重复绑定
			if (!this.tableFixedMediaQuery) return
			if (this.tableFixedMediaQuery.removeEventListener) {
				this.tableFixedMediaQuery.removeEventListener('change', this.updateTableFixedState)
			} else {
				this.tableFixedMediaQuery.removeListener(this.updateTableFixedState)
			}
		},
		methods: {
			// 初始化表格固定列媒体查询，并监听平板、手机端视口变化
			initTableFixedMediaQuery() {
				this.tableFixedMediaQuery = window.matchMedia('(max-width: 1024px)')
				this.updateTableFixedState(this.tableFixedMediaQuery)
				if (this.tableFixedMediaQuery.addEventListener) {
					this.tableFixedMediaQuery.addEventListener('change', this.updateTableFixedState)
				} else {
					this.tableFixedMediaQuery.addListener(this.updateTableFixedState)
				}
			},
			// 更新设备状态，并在固定列变化后重新计算表格布局
			updateTableFixedState(mediaQueryEvent) {
				this.isMobileOrTablet = mediaQueryEvent.matches
				this.$nextTick(() => {
					if (this.$refs.multipleTable) this.$refs.multipleTable.doLayout()
				})
			},
			// 拼接广告位类型与渲染类型展示文案
			getAdTypeRenderText(row) {
				if(!row.type){
					return '-'
				}
				if(row.isSelfRender === 1||row.isSelfRender === '1'){
					return `${row.type}（自渲染）`
				}
				if(row.isSelfRender === 0||row.isSelfRender === '0'){
					return `${row.type}（模版渲染）`
				}
				return row.type
			},
			// 日期选择器初始化
			dateInit() {
				this.datePicker = []
				this.datePickerDrawer = []
				let currentDate = new Date();
				// 减去一天的时间
				currentDate.setDate(currentDate.getDate() - 1);
				let year = currentDate.getFullYear();
				let month = String(currentDate.getMonth() + 1).padStart(2, '0');
				let day = String(currentDate.getDate()).padStart(2, '0');
				let formattedDate = `${year}-${month}-${day}`;
				this.datePicker.push(formattedDate);
				this.datePicker.push(formattedDate);
				this.datePickerDrawer.push(formattedDate);
				this.datePickerDrawer.push(formattedDate);
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				const classNames = [];
				// 判断当前行是否在 expandedRows 列表中
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.id === row.id);
				if (isExpanded) {
					classNames.push('success-row');
				}
				// 检查 adsId 是否存在
				if (!row.adsId) {
					classNames.push('icon-no');
				}
				return classNames.join(' ');
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			// 公司下拉列表选择
			companySelectChange(){
				this.mediaAppOptions = []
				this.getMediaAppOption();
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(query = null) {
				let data = {
					mediaCompany: this.queryData.companyName,
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
			},
			// 获取广告位下拉列表
			// async getMediaAdsOption() {
			// 	let res = await this.$http.get(this.$api.common.mediaAdsOption);
			// 	this.mediaAdsOptions = res.data
			// },
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startDate: '',
					endDate: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startDate = this.datePicker[0];
					data.endDate = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if (this.adsSelectForm.value) {
					data['adsId'] = this.adsSelectForm.value
				}
				if(this.appSelectForm.value){
					data['appId'] = this.appSelectForm.value
				}
				// if (this.tHeaderQueryChecked.length > 0) {
				// 	data['groupByIdList'] = this.tHeaderQueryChecked;
				// }
				let res = await this.$http.post(this.$api.dataManage.mediaIncomeList, data);
				this.tableData = res.data.mediaProfitRepDtoList.records
				this.total = res.data.mediaProfitRepDtoList.total
				if (res.data.mediaProfitRepDtoList && res.data.mediaProfitRepDtoList.records.length > 0) {
					let obj = {
						recordTime: '合计',
						companyName: '-',
						adName: '',
						type: '-',
						os: '-',
						appName: '',
						channelEstimateProfit: res.data.channelEstimateProfit !== null ? res.data.channelEstimateProfit : '-',
						divideEstimateProfit: res.data.divideEstimateProfit !== null ? res.data.divideEstimateProfit : '-',
						channelEcpm: res.data.channelEcpm !== null ? res.data.channelEcpm : '-',
						showNum: res.data.showNum,
						uniqueClickNum: res.data.uniqueClickNum,
						deductClickNum: res.data.deductClickNum,
						estimateProfit: res.data.estimateProfit,
						ecpm: res.data.ecpm,
						apiShowNum: res.data.apiShowNum ? res.data.apiShowNum : '-',
						apiClickNum: res.data.apiClickNum ? res.data.apiClickNum : '-',
						apiDeductClickNum: res.data.apiDeductClickNum,
						apiEstimateProfit: res.data.apiEstimateProfit ? res.data.apiEstimateProfit : '-',
						apiEcpm: res.data.apiEcpm ? res.data.apiEcpm : '-',
						showGapRate: res.data.showGapRate ? res.data.showGapRate : '-',
						clickGapRate: res.data.clickGapRate ? res.data.clickGapRate : '-',
						profitGapRate: res.data.profitGapRate ? res.data.profitGapRate : '-',
					}
					this.tableData.unshift(obj)
				}
			},
			checkBoxQueryChange(e,item,index){
				this.tHeaderQueryData[index].checked = e
				
				this.dimensionCheckAll = this.tHeaderQueryChecked.length === this.tHeaderQueryData.length
				this.isDimensionIndeterminate = this.tHeaderQueryChecked.length > 0 &&  this.tHeaderQueryChecked.length < this.tHeaderQueryData.length
				this.currentPage = 1
				this.getTableData();
			},
			handleCheckAllChangeDim(val){
				this.tHeaderQueryChecked = []
				if(val){
					this.tHeaderQueryData.forEach((item) => {
						this.tHeaderQueryChecked.push(item.valueNum)
					})
				}
				this.isDimensionIndeterminate = false;
				
				this.currentPage = 1
				this.getTableData();
			},
			appSeleteChange(e) {
				this.appSelectForm = e
				this.mediaAdsOptions = []
				this.adsSelectForm = {}
				this.getMediaAdsOption(2);
			},
			appRemoteMethod(query){
				clearTimeout();
				setTimeout(()=>{
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				},300)
			},
			adsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectForm = e
				}
			},
			adsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getMediaAdsOption(2, query)
				}, 300)
			},
			// 获取媒体广告位下拉列表
			async getMediaAdsOption(type, query = null) {
				let data = {
					adsName: query,
					appId: this.appSelectForm.value?this.appSelectForm.value:''
				}
				let res = await this.$http.get(this.$api.common.mediaAdsOption, data);
				this.adsRemoteLoading = false
				this.mediaAdsOptions = res.data
			},
			// 复制APP名称
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			handleSizeChangeDrawer(val) {
				this.currentPageDrawer = 1
				this.pageSizeDrawer = val
				this.getExpendTableData();
			},
			handleCurrentChangeDrawer(val) {
				this.currentPageDrawer = val
				this.getExpendTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.adsSelectForm = {}
				this.appSelectForm = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			addTableData() {
				this.companyFormData = {}
				this.companyDrawerShow = true
			},
			editTable(row, index) {
				row['editShow'] = true
				this.$set(this.tableData, index, row)
				// console.log(this.tHeadCheckedList)
			},
			async editConfirm(row, index) {
				row['editShow'] = false
				this.$set(this.tableData, index, row)
				let data = {
					id: row.id,
					showNum: row.showNum,
					deductClickNum: row.deductClickNum,
					estimateProfit: row.estimateProfit,
					ecpm: row.ecpm
				}
				let res = await this.$http.post(this.$api.dataManage.mediaIncomeEdit, data);
				if (res.code == 1) {
					this.$message.success('编辑成功');
					this.getTableData();
				}
			},
			confirmDrawerQuery() {
				this.currentPageDrawer = 1
				this.pageSizeDrawer = 10
				this.getExpendTableData();
			},
			// 表格展开方法
			handleExpandChange(row, expanded) {
				this.expandedRows = expanded
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.id === row.id);
				if (isExpanded) {
					this.tableData.forEach((item, index) => {
						if (row.id == item.id) {
							this.adsIdDrawer = row.adsId
							this.getExpendTableData(row,index);
						}
					})
				}
				this.orderSecBys = []
				this.sortSecField = {}
			},
			async getExpendTableData(row,index,orderBys = []) {
				let data = {
					startDate: row.recordTime,
					endDate: row.recordTime,
					adsId: this.adsIdDrawer,
					appProperty: this.queryData.appProperty
				}
				// if (this.datePicker && this.datePicker.length > 0) {
				// 	data.startDate = this.datePicker[0];
				// 	data.endDate = this.datePicker[1];
				// }
				// data = {...data,...this.queryDataDrawer}
				if(orderBys.length > 0){
					data['adOrderByReqs'] = orderBys;
				}
				let res = await this.$http.post(this.$api.dataManage.channelProfit, data);
				if (res.code == 1) {
					this.tableData[index].tabList = res.data
					// this.tableData[index].tabList.forEach((category, categoryIndex) => {
					// 	this.$set(category, 'uniqueClickNum', category.clickNum);
					// });
				}
				for (let i = 0; i < this.tableData.length; i++) {
					for (let j = 0; j < this.expandedRows.length; j++) {
						if (this.expandedRows[j].id == this.tableData[i].id) {
							this.expandedRows.splice(j, 1, this.tableData[i])
						}
					}
				}
				this.$forceUpdate();
			},
			channelDataDrawerOpen(row, index) {
				this.adsIdDrawer = row.adsId
				this.getExpendTableData();
				this.channelDataDrawerShow = true
			},
			closeDrawer() {
				this.currentPageDrawer = 1
				this.pageSizeDrawer = 10
				this.channelDataDrawerShow = false
			},
			confirmCompany(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.companyFormData;
						let res = await this.$http.post(this.$api.companyList, data);
						this.$message.success('编辑成功');
						this.closeDrawer();
						this.getTableData();
					}
				});
			},
			// 收益同步
			async mediaAsync(row) {
				let data = row.length ? row : [row]
				let res = await this.$http.post(this.$api.dataManage.mediaIncomeAsync, data);
				if (res.code == 1) {
					this.$message.success('同步成功');
					this.getTableData();
				}
			},
			// 一键同步
			mediaSyncAll() {
				let data = this.handleSelection;
				if (data === "" || !data.length) {
					this.$message.warning("请选择同步项！");
					return
				}
				data = data.map(item => {
					return item.id
				})
				this.$confirm('此操作将同步收入, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$refs.multipleTable.clearSelection(); // 清空选项
					this.mediaAsync(data);
				}).catch();
			},
			// 复选框
			handleSelectionChange(val) {
				this.handleSelection = val.map(res => {
					return {
						"reviewReduce": res.cut,
						"id": res.id
					}
				})
			},
			// 复选框控制
			checkSelectable(row, index) {
				// console.log(row.rstate);
				return !(index === 0)
			},
			// 导出
			async mediaExport(type) {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startDate: '',
					endDate: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startDate = this.datePicker[0];
					data.endDate = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if(type == 1){
					let res = await this.$http.post(this.$api.dataManage.mediaExport, data, 1);
					if (res.type != "application/json") {
						// const time = this.getTimeFun();
						let time = ''
						if(data.startDate == data.endDate){
							time = data.startDate
						}else{
							time = data.startDate + '-' + data.endDate
						}
						this.$http.downloads(res, `${time}媒体收入.xls`)
					}else{
						this.$message.error("导出失败");
					}
				}else{
					let resoults = await this.$http.post(this.$api.dataManage.channelProfitExport, data, 1);
					if (resoults.type != "application/json") {
						// const time = this.getTimeFun();
						let time = ''
						if(data.startDate == data.endDate){
							time = data.startDate
						}else{
							time = data.startDate + '-' + data.endDate
						}
						this.$http.downloads(resoults, `${time}分渠道数据.xls`)
					}else{
						this.$message.error("导出失败");
					}
				}
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
			// 表头高亮保持
			handleHeadAddClass({
				column
			}) {
				// console.log(column)
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			// 排序监听
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryData['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			sortChangeFunSec({
				column,
				prop,
				order
			},row,index){
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortSecField[prop] === order) {
					this.sortSecField[prop] = null
				} else {
					this.sortSecField[prop] = order
				}
				this.orderSecBys = []
				let direction = ''
				for (const i in this.sortSecField) {
					if (this.sortSecField[i]) {
						if (this.sortSecField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortSecField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderSecBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.getExpendTableData(row, index, this.orderSecBys); //调用后端查询接口
			},
			handleHeadAddClassSec({
				column
			}){
				if (this.sortSecField[column.property]) {
					column.order = this.sortSecField[column.property]
				}
			},
			// 阻止默认上传
			uploadSet(){},
			// 导入
			async uploadFun(file,type) {
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				let res = await this.$http.post(this.$api.dataManage.mediaImport, formdata);
				if(res.code == 1){
					this.$message.success(res.msg);
					this.getTableData();
				}
			},
			editTheadDialog() {
				this.tHeadDialogVisible = true
				if (localStorage.getItem('sdk-mediaIncomeTHead')) {
					this.tHeadCheckShowList = JSON.parse(localStorage.getItem('sdk-mediaIncomeTHead'))
					this.tHeadCheckedList = JSON.parse(localStorage.getItem('sdk-mediaIncomeTHead'))
				}else{
					this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
					this.tHeadCheckShowList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
				}
				// 初始化分组状态
				this.initGroupStates();
			},
			// 初始化分组状态
			initGroupStates() {
				// 重置所有分组的选中状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					category.groupChecked = false;
					category.isIndeterminate = false;
				});
				// 遍历选中的列，设置对应的 checked 状态
				this.tHeadCheckShowList.forEach((item) => {
					this.tHeadAllList.forEach((category, categoryIndex) => {
						const foundItem = category.list.find(items => items.label === item.label);
						if (foundItem) {
							this.$set(foundItem, 'checked', true);
						}
					});
				});
				// 更新所有分组的状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					this.updateGroupState(categoryIndex);
				});
			},
			closeTHeadDialog() {
				this.tHeadDialogVisible = false
			},
			confirmTHeadDialog() {
				if (this.tHeadCheckShowList.length <= 0) {
					this.$message.warning("请选择要展示的指标");
				}
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadCheckShowList));
				localStorage.removeItem('sdk-mediaIncomeTHead');
				localStorage.setItem('sdk-mediaIncomeTHead', JSON.stringify(this.tHeadCheckedList))
				this.$message.success("保存成功");
				this.closeTHeadDialog();
			},
			// 单个选中
			checkChange(e, index, items, indexs) {
				if (e === true) {
					this.tHeadCheckShowList.push(items)
				} else {
					const idx = this.tHeadCheckShowList.findIndex(item => item.label === items.label);
					if (idx !== -1) {
						this.tHeadCheckShowList.splice(idx, 1);
					}
				}
				// 更新分组状态
				this.updateGroupState(index);
			},
			updateGroupState(groupIndex) {
				const group = this.tHeadAllList[groupIndex];
				if (!group) return;
				const list = group.list;
				const checkedCount = list.filter(item => item.checked).length;
				const totalCount = list.length;
				// 更新全选状态
				group.groupChecked = checkedCount === totalCount;
				// 更新半选状态
				group.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
			},
			// 分组选中
			handleGroupCheckChange(e, item, index) {
				item.isIndeterminate = false;
				if (e === true) {
					// 将 item.list 下的所有对象 checked 设为 true
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', true);
					});
					// 去重版本的合并
					const newItems = item.list.filter(newItem =>
						!this.tHeadCheckShowList.some(existingItem => existingItem.label === newItem.label)
					);
					this.tHeadCheckShowList = this.tHeadCheckShowList.concat(newItems);
				} else {
					const labelsToRemove = item.list.map(items => items.label);
					this.tHeadCheckShowList = this.tHeadCheckShowList.filter(item1 => !labelsToRemove.includes(item1.label));
					// 可选：取消分组选中时也将 checked 设为 false
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', false);
					});
				}
			},
			// 删除check-box的选中
			deleteTHeadChecked(item, index) {
				let foundGroupIndex = -1;
				// 遍历每个分类
				this.tHeadAllList.forEach((category, categoryIndex) => {
					// 在当前分类的 list 中查找匹配的项
					const foundItem = category.list.find(items => items.label === item.label);
					if (foundItem) {
						this.$set(foundItem, 'checked', false);
						// 记录找到的分组索引
						foundGroupIndex = categoryIndex;
					}
				});
				this.tHeadCheckShowList.splice(index, 1);
			
				// 如果找到了对应的分组，更新该分组的状态
				if (foundGroupIndex !== -1) {
					this.updateGroupState(foundGroupIndex);
				}
			},
			handleDragStart(e, item) {
				this.dragging = item.label;
			},
			handleDragEnd(e, item) {
				this.dragging = null
			},
			//首先把div变成可以放置的元素，即重写dragenter/dragover
			handleDragOver(e) {
				e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
			},
			handleDragEnter(e, item) {
				e.dataTransfer.effectAllowed = "move";
				// 如果拖拽目标是自身，则不处理
				if (item.label === this.dragging) {
					return;
				}
				try {
					const newItems = [...this.tHeadCheckShowList];
					// 查找源元素和目标元素的位置
					const src = newItems.findIndex(i => i.label === this.dragging);
					const dst = newItems.findIndex(i => i.label === item.label);
					// 验证索引有效性
					if (src === -1) {
						console.warn(`找不到源元素: ${this.dragging}`);
						return;
					}
					if (dst === -1) {
						console.warn(`找不到目标元素: ${item.label}`);
						return;
					}
					// 如果源和目标相同，不处理
					if (src === dst) {
						return;
					}
					// 移动元素
					const [movedItem] = newItems.splice(src, 1);
					newItems.splice(dst, 0, movedItem);
					this.tHeadCheckShowList = newItems;
				} catch (error) {
					console.error('拖拽操作出错:', error);
				}
			}
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}
	
	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}
	
	.el-form {
		flex-wrap: wrap;
	}
	
	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}
	
	/deep/ .icon-no .el-table__expand-icon {
		display: none;
	}
	
	/deep/ .el-form-item__content {
		line-height: 32px;
	}
	
	.searchMenuRight{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 82px;
	}
	
	
	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}
	
	.tableBtns{
		height: 32px;
		margin-left: auto;
	}

	/deep/ .icon-no .el-table__expand-icon {
		display: none;
	}

	.query-menu-right {
		margin-left: auto;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		/* padding-right: 30px; */
		margin-top: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}


	.el_tables /deep/ tr {
		background-color: #F6FEFF !important;
	}

	.el_tables {
		font-size: 12px !important;
		background-color: #F6FEFF !important;
	}

	.el_table /deep/.el-table__expanded-cell {
		padding: 0 !important;
		padding-left: 100px !important;
		background-color: #F6FEFF !important;
	}

	.el_table /deep/ .caret-wrapper {
		/* height: 24px;
		line-height: 24px; */
	}
	
	/deep/ .success-row {
		background-color: #EBFAFF !important;
	}
	.upload-demo{
		margin-left: 10px;
		height: 32px;
	}
	.upload-demo /deep/.el-upload{
		height: 32px !important;
	}
	.upload-demo /deep/.el-button--small{
		height: 32px !important;
		/* line-height: 32px; */
	}
	
	
	
	.tHeadRow{
		align-items: center;
		margin-bottom: 20px;
	}
	.tHeadleftTips{
		font-size: 12px;
		margin-right: 20px;
	}
	
	.menu-right {
		margin-left: auto;
		margin-bottom: 20px;
		align-items: center;
	}
	
	.setLabel {
		margin-left: 10px;
		font-size: 30px;
		cursor: pointer;
	}
	
	
	.tHeadEditBox {
		border: 1px solid #C2CEDF;
		padding: 12px;
		box-sizing: border-box;
	}
	
	.tHeadAllList {
		width: 49%;
		height: 490px;
		overflow-y: auto;
	}
	
	.checkList {
		width: 100%;
		flex-wrap: wrap;
		/* padding-right: 15px; */
		box-sizing: border-box;
	}
	
	.el_check_box {
		margin-bottom: 15px;
		margin-right: 0;
		width: 50%;
	}
	
	/deep/.el-collapse-item__header {
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	
	/deep/.el-collapse-item__content {
		padding-bottom: 10px;
	}
	
	.tHeadCheckShowBox {
		width: 49%;
		background: #F0F2F5;
		padding: 16px 18px;
		box-sizing: border-box;
	}
	
	.tHeadCheckShowTitle {
		font-size: 14px;
		color: #4E5865;
	}
	
	.tHeadCheckShowTips {
		font-size: 12px;
		color: #8E98AA;
	}
	
	.tHeadCheckShowList {
		border: 1px solid #C3CDE0;
		border-bottom: none;
		margin-top: 8px;
		height: 420px;
		overflow-y: auto;
	}
	
	.tHeadCheckedOne {
		width: 100%;
		height: 34px;
		line-height: 34px;
		align-items: center;
		border-bottom: 1px solid #C3CDE0;
		padding: 0 8px;
		font-weight: 500;
		font-size: 14px;
		color: #4E5866;
		box-sizing: border-box;
		cursor: pointer;
	}
	
	.tHeadCheckedOne div {
		margin-left: 4px;
	}
	
	.tHeadCheckedOne img {
		width: 16px;
		height: 16px;
	}
	
	.tHeadCheckedOne i {
		font-size: 18px;
	}
	.tHeadFixedCheckList{
		flex-wrap: wrap;
		width: 40%;
	}
	.check-box-fixed{
		/* margin-bottom: 10px; */
	}
	
	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.selectAppId {
		color: #999999;
		align-items: center;
	}
	
	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}
</style>
